













import { Vue, Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import axios from 'axios';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import { IProject, IMarkers } from '@/interfaces/data';
import store from '@/store';

@Component({
  components: {
    GmapCluster
  }
})
export default class LeafletMapView extends Vue {
  @(namespace('LocationModule').State('tempMarkers'))
  private tempMarkers!: IMarkers[];
  private index = null;
  private infoWindowPos = null;
  private infoWinOpen = false;
  private currentMidx = null;
  private infoOptions = {
    content: '',
    pixelOffset: {
      width: 0,
      height: -35
    }
  };

  private filterCoverageIcon(marker: { coverage: string }) {
    return marker.coverage
      ? { url: require('@/assets/green-dot.png') }
      : { url: require('@/assets/red-dot.png') };
  }

  private toggleInfoWindow(marker, idx) {
    this.infoWindowPos = marker.position;
    this.infoOptions.content = `<p>lat:${marker.position.lat}</p>
                                <p>lng: ${marker.position.lng}</p>
                                <p>covearge: ${marker.coverageStatus}</p>
                                <p>margins: ${marker.margins}`;

    if (this.currentMidx === idx) {
      this.infoWinOpen = !this.infoWinOpen;
    } else {
      this.infoWinOpen = true;
      this.currentMidx = idx;
    }
  }
  private created() {
    store.commit('LocationModule/clearAllMarkers');
  }
}
